document.addEventListener('DOMContentLoaded', function () {
  // =============================
  // 1) EFECTO PALABRA A PALABRA EN EL H1
  // =============================
  const h1 = document.querySelector('.tyr-hero-title');
  if (h1 && !h1.querySelector('.word-fade')) {
    const text = h1.textContent.trim().replace(/\s+/g, ' ');
    if (text) {
      const words = text.split(' ');
      h1.textContent = '';

      words.forEach((w, i) => {
        const span = document.createElement('span');
        span.textContent = w;
        span.className = 'word-fade';

        // Delay más lento entre palabras
        span.style.animationDelay = (i * 0.55) + 's';

        h1.appendChild(span);

        if (i < words.length - 1) {
          h1.append(' ');
        }
      });
    }
  }

  // =============================
  // 2) OCULTAR / MOSTRAR CONTENIDO DEL HERO + LÓGICA AUTOPLAY/POSTER
  // =============================
  const heros = document.querySelectorAll('.tyr-hero');

  heros.forEach(function (hero) {

    const content   = hero.querySelector('.tyr-hero__content');
    const title     = hero.querySelector('.tyr-hero-title');
    const paragraph = hero.querySelector('.tyr-paragraph.rte');

    /* ============================================================
       LÓGICA VÍDEO / POSTER — SOLO SI FALLA AUTOPLAY
       ============================================================ */
    const video     = hero.querySelector('.tyr-hero__video');
    const posterBtn = hero.querySelector('.tyr-hero__poster');

    if (video && posterBtn) {

      function showPoster() {
        hero.classList.add('tyr-hero--autoplay-failed');
        try { video.pause(); } catch (e) {}
      }

      function hidePoster() {
        hero.classList.remove('tyr-hero--autoplay-failed');
      }

      // 1) Damos un pequeño margen y comprobamos si el autoplay ha arrancado
      setTimeout(() => {
        // Si sigue en pausa o en el segundo 0, asumimos que NO ha arrancado
        if (video.paused || video.currentTime === 0) {
          console.log('[HERO] Autoplay fallido, muestro póster');
          showPoster();
        } else {
          console.log('[HERO] Autoplay OK, no muestro póster');
        }
      }, 1200);

      // 2) Si el usuario toca la imagen con el icono de play:
      posterBtn.addEventListener('click', () => {
        console.log('[HERO] Click en póster, intento reproducir');
        hidePoster();
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.catch(err => {
            console.log('[HERO] Error al reproducir tras click:', err);
            showPoster();
          });
        }
      });
    }

    /* ============================================================
       LÓGICA DE OCULTAR / MOSTRAR TEXTO
       ============================================================ */
    if (!content) return;

    let hideTimeout = null;

    function hideContent() {
      content.classList.add('tyr-hero__content--hidden');
      if (title)     title.classList.add('tyr-hide-hero');
      if (paragraph) paragraph.classList.add('tyr-hide-hero');
    }

    function showContent() {
      content.classList.remove('tyr-hero__content--hidden');
      if (title)     title.classList.remove('tyr-hide-hero');
      if (paragraph) paragraph.classList.remove('tyr-hide-hero');
    }

    function scheduleHide() {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
      }
      hideTimeout = setTimeout(hideContent, 5000);
    }

    // Estado inicial: se ve todo y se programa ocultar a los 5s
    showContent();
    scheduleHide();

    function handleInteraction() {
      showContent();
      scheduleHide();
    }

    // Interacciones que hacen reaparecer el texto y reprograman el ocultado
    ['scroll', 'mousemove', 'touchstart'].forEach(function (evt) {
      window.addEventListener(evt, handleInteraction, { passive: true });
    });

  });
});
